import * as yup from 'yup';
import i18n from '../i18n';

const t = (key) => i18n.t(key);

export const contactFormSchema = yup.object().shape({
  name: yup
    .string()
    .required(() => t('validation.nameRequired'))
    .min(2, () => t('validation.nameMin'))
    .max(50, () => t('validation.nameMax')),
  email: yup
    .string()
    .required(() => t('validation.emailRequired'))
    .email(() => t('validation.emailInvalid')),
  phone: yup
    .string()
    .matches(/^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/, () => t('validation.phoneInvalid')),
  subject: yup
    .string()
    .required(() => t('validation.subjectRequired'))
    .min(5, () => t('validation.subjectMin')),
  message: yup
    .string()
    .required(() => t('validation.messageRequired'))
    .min(10, () => t('validation.messageMin'))
    .max(1000, () => t('validation.messageMax'))
});

export const loginFormSchema = yup.object().shape({
  email: yup
    .string()
    .required('Email is required')
    .email('Invalid email format'),
  password: yup
    .string()
    .required('Password is required')
    .min(6, 'Password must be at least 6 characters')
});

export const galleryItemSchema = yup.object().shape({
  title: yup
    .string()
    .required('Title is required')
    .min(3, 'Title must be at least 3 characters'),
  description: yup
    .string()
    .max(500, 'Description must be less than 500 characters'),
  category: yup
    .string()
    .required('Category is required'),
  displayOrder: yup
    .number()
    .required('Display order is required')
    .min(0, 'Display order must be positive')
});

export const teamMemberSchema = yup.object().shape({
  name: yup
    .string()
    .required('Name is required')
    .min(2, 'Name must be at least 2 characters'),
  role: yup
    .string()
    .required('Role is required'),
  bio: yup
    .string()
    .max(300, 'Bio must be less than 300 characters')
});

export const companyInfoSchema = yup.object().shape({
  name: yup
    .string()
    .required('Company name is required'),
  email: yup
    .string()
    .required('Email is required')
    .email('Invalid email format'),
  phone: yup
    .string()
    .required('Phone is required'),
  address: yup
    .string()
    .required('Address is required')
});
